import React, { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./firebase";
import FileExplorer from "./components/FileExplorer";
import Login from "./components/Login";


const App = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return () => unsubscribe();
  }, []);

  return (
    <div>
      {user ? (
        <>
          <FileExplorer user={user} />
        </>
      ) : (
        <Login onLogin={setUser} />
      )}
    </div>
  );
};

export default App;
